<template>
  <b-overlay :show="getFormLoading" spinner-variant="primary">
    <b-form>
      <b-form-group label="Projekt neve">
        <b-form-input
          v-model="form.Nev"
          autocomplete="off"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group label="Magazin cím">
        <k-basic-ckeditor
          v-model="form.MagazinCim"
          :fontBackgroundColor="false"
          :lists="false"
          :media="false"
          :code="false"
          :table="false"
          required
        ></k-basic-ckeditor>
      </b-form-group>
      <b-form-group label="Youtube csatorna">
        <b-form-input
          v-model="form.YoutubeUrl"
          autocomplete="off"
        ></b-form-input>
        <b-form-text>
          Például https://www.youtube.com/feeds/videos.xml?channel_id=csatornaId
        </b-form-text>
      </b-form-group>
      <b-form-group label="Downloader link">
        <b-form-input
          v-model="form.DownloaderLink"
          autocomplete="off"
        ></b-form-input>
        <b-form-text>
          Például https://www.streamnext.hu/BvNewsDownloader
        </b-form-text>
      </b-form-group>
      <b-form-group label="Weboldalak, ahol a magazin megjelenhet">
        <b-form-textarea
          v-model="form.BeagyazasUrl"
          autocomplete="off"
          placeholder="Sorolja fel azon oldalak URL-jeit, amikbe be szeretné ágyazni a magazinját"
        ></b-form-textarea>
        <b-form-text>
          Például: petkupa.hu
        </b-form-text>
      </b-form-group>
      <b-form-group label="Landing screen">
        <k-file-select
          accept="image/*"
          @inputBase64="form.LandingScreen = $event[0]"
        >
          <img
            class="file-select-img-preview border-radius-6"
            :src="form.LandingScreen || $placeholderImage"
            alt="Landing screen"
          />

          <div class="fab-blur absolute-bottom-right-10">
            <i class="fas fa-edit text-black "></i>
          </div>
        </k-file-select>
      </b-form-group>
      <b-form-group label="Magazin háttérszín">
        <div class="d-flex align-items-center">
          <b-form-input
            v-model="form.Hatterszin1"
            type="color"
            autocomplete="off"
            required
          ></b-form-input>
          <i class="fa fa-long-arrow-alt-right mx-4"></i>
          <b-form-input
            v-model="form.Hatterszin2"
            type="color"
            autocomplete="off"
            required
          ></b-form-input>
        </div>
      </b-form-group>
      <b-form-group label="Alapértelmezett cikk">
        <k-cikk-valaszto v-model="form.DefaultCikk"></k-cikk-valaszto>
      </b-form-group>
      <k-pcf-linkek :form="form"></k-pcf-linkek>
      <k-pcf-szervezetek :form="form"></k-pcf-szervezetek>
      <k-pcf-kategoriak :form="form"></k-pcf-kategoriak>
      <k-pcf-cimkek :form="form"></k-pcf-cimkek>
      <k-pcf-feliratok :form="form"></k-pcf-feliratok>

      <b-form-group>
        <b-form-checkbox v-model="form.BelepesGombFl">
          Belépés gomb
        </b-form-checkbox>
      </b-form-group>
      <b-form-group label="Blokkok láthatósága">
        <ul class="list-group dense">
          <li class="list-group-item">
            <b-form-checkbox v-model="form.HeaderFl">
              Header blokk
            </b-form-checkbox>
            <b-form-checkbox v-model="form.AktivSzerzokFl">
              Aktív szerzők blokk
            </b-form-checkbox>
            <b-form-checkbox v-model="form.SokanOlvastakFl">
              Sokan olvasták blokk
            </b-form-checkbox>
            <b-form-checkbox v-model="form.YoutubeFl">
              YouTube blokk
            </b-form-checkbox>
          </li>
        </ul>
      </b-form-group>
      <b-form-group label="Mobil alkalmazás csomag neve">
        <b-form-input
          v-model="form.MobilCsomagNev"
          autocomplete="off"
        ></b-form-input>
        <b-form-text>
          Például hu.konasoft.streamnext.mobile.tudaster
        </b-form-text>
      </b-form-group>
      <b-form-group label="Noémi2 projekt ID">
        <b-form-input
          v-model="form.Noemi2ProjektId"
          type="number"
          min="1"
          autocomplete="off"
        ></b-form-input>
      </b-form-group>
      <b-form-group>
        <b-form-checkbox v-model="form.MagazinAppFl">
          Mobil alkalmazás a magazinra mutat
        </b-form-checkbox>
        <b-form-text>
          Ha StreamNext magazint nyit az app, jelöld ki ezt a pipát
        </b-form-text>
      </b-form-group>
      <b-form-group label="Projekt azonosítója">
        <div><input class="showtext" v-model="form.Azonosito" readonly /></div>
        <b-form-text>
          Ez a csatolmányokban a mappa neve
        </b-form-text>
      </b-form-group>
      <b-form-group label="API kulcs">
        <div>
          <input
            class="showtext"
            ref="apiKulcs"
            v-model="form.ApiKulcs"
            readonly
          />
          <button
            class="btn k-btn"
            type="button"
            v-if="form.ApiKulcs"
            @click="copyApiKey()"
          >
            <i class="fa fa-copy"></i>
          </button>
        </div>
        <b-form-text>
          Ezzel a kulccsal lehet beágyazni a magazint.<br />
          <a
            :href="link"
            target="_blank"
            ref="apiLink"
            >{{ link }}</a
          >
          <button
            class="btn k-btn"
            type="button"
            v-if="form.ApiKulcs"
            @click="copyLink()"
          >
            <i class="fa fa-copy"></i>
          </button>
        </b-form-text>
      </b-form-group>

      <div class="sticky-bottom py-2 mt-4 bg-white">
        <k-button
          @click="OnSubmit"
          variant="primary"
          label="Mehet"
          icon="fa-check"
          :loading="saveFormLoading"
        ></k-button>
      </div>
    </b-form>
  </b-overlay>
</template>

<script>
import { mapGetters } from 'vuex';
import { NotificationFunctions } from '../../../functions/NotificationFunctions';
import cloneDeep from 'lodash/cloneDeep';
import { AppStoreTypes } from '../../../store/modules/app';
import { projektService } from '../../../services/ProjektService';
import { hidrateForm } from '../../../utils/common';
import { AppFunctions } from '../../../functions/AppFunctions';
import settings from '../../../settings';

let getDefaultForm = () => {
  return {
    Id: -1,
    Azonosito: '',
    ApiKulcs: '',
    Nev: '',
    Hatterszin1: '#ffffff',
    Hatterszin2: '#ffffff',
    YoutubeUrl: '',
    DownloaderLink: '',
    BeagyazasUrl: null,
    MagazinCim: '',
    LandingScreen: '',
    DefaultCikk: null,
    Szervezetek: [],
    Linkek: [],
    Menuk: [],
    Cimkek: [],
    Nyelvesites: [],
    HeaderFl: true,
    BelepesGombFl: false,
    AktivSzerzokFl: true,
    SokanOlvastakFl: true,
    YoutubeFl: true,
    MobilCsomagNev: null,
    MagazinAppFl: false,
    Noemi2ProjektId: null
  };
};

export default {
  name: 'project-config-form',
  data() {
    return {
      ct: -1,
      getFormLoading: false,
      saveFormLoading: false,
      form: cloneDeep(getDefaultForm()),
      settings,
    };
  },
  mounted() {},
  created() {
    this.GetForm();
  },
  methods: {
    async GetForm() {
      this.getFormLoading = true;
      try {
        let data = await projektService.GetProjektConfigForm();
        hidrateForm(this, this.form, data);
      } catch (error) {
        NotificationFunctions.AjaxError({ error });
      }
      this.getFormLoading = false;
    },
    async OnSubmit() {
      this.saveFormLoading = true;
      try {
        let data = {
          ...this.form,
        };
        await projektService.SaveProjektConfigForm(data);
        NotificationFunctions.SuccessAlert(
          'Projekt config',
          'A projekt módosítása megtörtént'
        );
        this.GetForm();
      } catch (error) {
        NotificationFunctions.AjaxError({ error });
      }
      this.saveFormLoading = false;
    },
    copyApiKey() {
      var copyText = this.$refs.apiKulcs;
      /* Select the text field */
      copyText.select();
      copyText.setSelectionRange(0, 99999); /* For mobile devices */

      if (window.clipboardData) {
        // Internet Explorer
        window.clipboardData.setData('Text', this.form.ApiKulcs);
      } else if (navigator) {
        navigator.clipboard.writeText(this.form.ApiKulcs);
      }

      NotificationFunctions.SuccessAlert(
          'API kulcs',
          'A kulcsot vágólapra helyeztem!'
        );
    },
    copyLink() {
      var copyText = this.$refs.apiLink.href;
      if (window.clipboardData) {
        // Internet Explorer
        window.clipboardData.setData('Text', copyText);
      } else if (navigator) {
        navigator.clipboard.writeText(copyText);
      }
      NotificationFunctions.SuccessAlert(
          'API link',
          'A linket vágólapra helyeztem!'
        );
    },
  },
  computed: {
    ...mapGetters({
      user: AppStoreTypes.user.get,
    }),
    isSzerkeszto() {
      return AppFunctions.IsSzerkeszto(this.user);
    },
    link() {
      return settings.prodBaseUrl + '?apiKey=' + this.form.ApiKulcs;
    },
    cname() {
      return this.form.Azonosito.toLowerCase().replace(' ', '').replace('-', '').replace('_', '');
    }
  },
  watch: {},
  props: {},
};
</script>


<style itemscope>
  .ck-editor__editable {
    min-height: unset !important;
    border: 1px solid #ced4da !important;
    border-radius: 0.25rem !important;
  }
  .showtext {
    border: none;
    width: 300px;
  }
</style>